import { registerOverlayResetHandler, registerSessionCacheClearHandler } from '../../shared/ports/sessionResetPort';
import { useCatalogOverlayStore } from '../store/useCatalogOverlayStore';
import { resetCatalogHydrationState } from '../infra/catalogHydrationState';
import { resetCatalogReadPreflightState } from '../infra/catalogReadPreflight';
import { resetCatalogSnapshotSyncRuntimeState, syncCatalogSnapshotFromRemote } from '../infra/catalogSnapshotSync';
import { clearCatalogRamSnapshotCache } from '../infra/catalogRamSnapshotCache';

registerOverlayResetHandler(() => {
  useCatalogOverlayStore.getState().resetAll();
});

registerSessionCacheClearHandler(() => {
  resetCatalogHydrationState();
  resetCatalogSnapshotSyncRuntimeState();
  resetCatalogReadPreflightState();
  clearCatalogRamSnapshotCache();
  // Race condition fix: ensureLocalDataMatchesAuthUser may clear the web cache
  // AFTER the initial catalog sync populated it. Re-sync to repopulate the cache
  // so masters (brands, categories, suppliers) are visible after account switch.
  void syncCatalogSnapshotFromRemote({ force: true, forceFull: true }).catch(() => {});
});
